import React from 'react';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import useCurrentTextStyle from '../../../../hooks/useCurrentTextStyle';

export const ProductVendor = ({ product, block, isMobile, settings, globals }) => {
  const { getCurrentTextStyle } = useCurrentTextStyle();
  
  // Get breakpoint states for responsive logic and render type checks
  const isMobileQuery = useMediaQuery(null, 767);
  const isTablet = useMediaQuery(768, 1023);
  const isDesktop = useMediaQuery(1024, 1439);
  const isUltrawide = useMediaQuery(1440, null);
  
  const {
    render_type,
    render_type_mobile,
    render_type_tablet,
    render_type_desktop,
    render_type_ultrawide,
    override_render_type,
    color_scheme,
    vendor_style,
    vendor_style_mobile,
    vendor_style_tablet,
    vendor_style_ultrawide,
    vendor_style_enable_responsive,
    vendor_alignment,
    vendor_prefix,
    vendor_uppercase,
    vendor_link,
    padding_top,
    padding_right,
    padding_bottom,
    padding_left,
    margin_top,
    margin_right,
    margin_bottom,
    margin_left,
    classes
  } = settings;



  const shouldShow = (() => {
    if (override_render_type) {
      if (isMobileQuery && render_type_mobile === 'hide') return false;
      if (isTablet && render_type_tablet === 'hide') return false;
      if (isDesktop && render_type_desktop === 'hide') return false;
      if (isUltrawide && render_type_ultrawide === 'hide') return false;
      return true;
    } else {
      if (render_type === 'mobile-only' && !isMobileQuery) return false;
      if (render_type === 'tablet-only' && !isTablet) return false;
      if (render_type === 'desktop-only' && !isDesktop) return false;
      if (render_type === 'ultrawide-only' && !isUltrawide) return false;
      return true;
    }
  })();

  if (!shouldShow || !product?.vendor) return null;

  // Build vendor text with prefix
  const vendorText = `${vendor_prefix || ''}${product.vendor}`;

  // Build CSS classes
  const vendorClasses = [
    `color-${color_scheme || 'scheme-1'}`,
    getCurrentTextStyle(vendor_style, vendor_style_enable_responsive, vendor_style_mobile, vendor_style_tablet, vendor_style_ultrawide),
    vendor_uppercase ? 'uppercase' : '',
    `text-${vendor_alignment}`,
    `pt-[${padding_top}px]`,
    `pb-[${padding_bottom}px]`,
    `pl-[${padding_left}px]`,
    `pr-[${padding_right}px]`,
    `mt-[${margin_top}px]`,
    `mb-[${margin_bottom}px]`,
    `ml-[${margin_left}px]`,
    `mr-[${margin_right}px]`,
    classes || ''
  ].filter(Boolean).join(' ');

  return (
    <div className={vendorClasses}>
      {vendor_link ? (
        <a 
          href={`/collections/vendors?q=${encodeURIComponent(product.vendor)}`}
        >
          {vendorText}
        </a>
      ) : (
        <>
          {vendorText}
        </>
      )}
    </div>
  );
};